import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setIsPending, setError, setData } from "../redux/slices/fetchStatusSlice";
import MetricsDataFormatter from "../classes/MetricsDataFormatter"
import LocalMetrics from "../classes/LocalMetrics";

import MetricsApi from "../classes/metricsApi"
const metricsApi = new MetricsApi()

const useUpdateMetricsOnUserSelection = () =>{
    const { queries } = useSelector((state) => state.fetchStatus)
    const dispatch = useDispatch()

    const formatData = (data) => {
        return new MetricsDataFormatter().format(data)
    }
    useEffect(() => {
        if(!queries) return 
        (async () => {
            try {
                dispatch(setIsPending(true))
                const data = await metricsApi.getMetrics(queries)
                const formattedData = formatData(data)
                const localMetrics = new LocalMetrics()
                localMetrics.update(formattedData, dispatch)
                dispatch(setIsPending(false))
                dispatch(setData(data))
            } catch(e) {
                dispatch(setIsPending(false))
                dispatch(setError(e))
            }
        })()
        
    }, [ queries ])
}

export default useUpdateMetricsOnUserSelection


